module.exports = __webpack_public_path__ + "img/WinLose2.62080b93.png";